import { createCommand } from '@commander-js/extra-typings';
import type { GetRootCommandFn } from '@wix/cli-command-contract';
import { devCommand } from './dev.js';
import { previewCommand } from './preview.js';
import { publishCommand } from './publish.js';
import { installCommand } from './install.js';
import { uninstallCommand } from './uninstall.js';

export const getRootCommand: GetRootCommandFn = async function getRootCommand(
  services,
  cliVersion
) {
  return createCommand('site')
    .addCommand(devCommand(services, cliVersion))
    .addCommand(previewCommand(services, cliVersion))
    .addCommand(publishCommand(services, cliVersion))
    .addCommand(installCommand(services, cliVersion))
    .addCommand(uninstallCommand(services, cliVersion));
};
